export default __webpack_public_path__ + "static/media/Minor Rune Stone of the Claret Trail.08374fca.jpg";